import { TRUCK_TABS } from "../../../components/Trucks/consts";
import {
  BUTTON_CATEGORIES_ARRAY,
  SIZE_NUMBER_ARRAY,
  TEXT_DIMENSION_ARRAY
} from "../../../config/constants";

export enum COLOR_VALUES {
  ox_2_transparent = "transparent",
  ox_2_primary = "#e7b522",
  ox_2_less_primary = "#e3b221",
  ox_2_faded_primary = "#e7b52229",
  ox_2_extra_faded_primary = "#e7b5221a",
  ox_2_blue = "#4AC3FC",
  ox_2_dark_blue = "#2a3548",
  ox_2_darker_blue = "#18202E",
  ox_2_light_blue = "#a2b3d1",
  ox_2_white = "#ffffff",
  ox_2_light_white = "#fcfcfc",
  ox_2_greyish_white = "#eaeff2",
  ox_2_lighter_grey = "#d8d8d8",
  ox_2_orange = "#ed7818",
  ox_2_light_orange = "#ED781814",
  ox_2_red = "#bd062d",
  ox_2_lighter_red = "#FCF2f4",
  ox_2_black = "#000000",
  ox_2_black_shadow = "#0000001a",
  ox_2_green = "#CDDF00",
  ox_2_text_green = "#4ac404",
  ox_2_input_white = "#EAEFF2",
  ox_2_grey = "#707070",
  ox_2_faded_primary_bg = "#FEFBF3",
  ox_2_light_cyan = "#F5F8FC",
  ox_2_green_bg = "#CDDF0014"
}

export type SIZE_NUMBER = (typeof SIZE_NUMBER_ARRAY)[number];

export type BUTTON_CATEGORIES = (typeof BUTTON_CATEGORIES_ARRAY)[number];

// Text
export type TEXT_DIMENSION = (typeof TEXT_DIMENSION_ARRAY)[number];

export enum TEXT_FONT_WEIGHT {
  bold = "bold",
  light = "light",
  black = "black",
  medium = "medium",
  semibold = "semibold",
  normal = "normal"
}

export enum ALERT_STATUS {
  "PENDING",
  "SNOOZED",
  "READ",
  "REVIEWED",
  "JUSTIFIED"
}

export enum USER_TYPES {
  "ADMIN_GUEST" = "ADMIN_GUEST",
  "DISPATCHER" = "DISPATCHER",
  "ADMIN" = "ADMIN",
  "SUPER_ADMIN" = "SUPER_ADMIN"
}

export enum ORDER_SHOW_OPTIONS {
  ORDER_COMPLETED = "ORDER_COMPLETED",
  PAYMENT_PAID = "PAYMENT_PAID",
  PAYMENT_HALF_PAID = "PAYMENT_HALF_PAID",
  PAYMENT_PENDING = "PAYMENT_PENDING"
}

export enum SALES_SHOW_OPTIONS {
  PAYMENT_PAID = "PAYMENT_PAID",
  PAYMENT_HALF_PAID = "PAYMENT_HALF_PAID",
  PAYMENT_PENDING = "PAYMENT_PENDING",
  SALE_CANCELLED = "SALE_CANCELLED"
}

export enum EBM_SALES_SHOW_OPTIONS {
  NORMAL_SALE = "NORMAL_SALE",
  NORMAL_REFUND = "NORMAL_REFUND"
}

export enum EBM_PURCHASES_SHOW_OPTIONS {
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  REJECTED = "REJECTED"
}

export enum TRUCKS_SHOW_OPTIONS {
  IN_SHIFT = "IN_SHIFT",
  NOT_IN_SHIFT = "NOT_IN_SHIFT",
  HAS_ORDER = "HAS_ORDER"
}

export type TruckTabs = (typeof TRUCK_TABS)[number];

export enum TruckHealthTabs {
  insp = "insp", // inspection
  rl = "rl" // repair logs
}

export enum SettingsTabs {
  acc = "acc", // account
  shifts_categories = "shifts_categories",
  trucks = "trucks",
  kpi = "kpi",
  pymnts = "pymnts", // payments
  energy = "energy",
  measurements = "measurements",
  apk = "apk",
  role_management = "role_management",
  ebm_configs = "ebm_configs",
  ebm_items = "ebm_items"
}

export enum TruckSettingsTabs {
  insp = "insp", // inspection
  srvc = "srvc" // serviceing
}

export enum NEW_CHECK_FORM_TABS {
  NUMBER = "NUMBER",
  RADIO = "RADIO",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE"
}

export enum CHECK_ITEM_RESULT_ENUMS {
  PASS = "PASS",
  MINOR_FAIL = "MINOR_FAIL",
  MAJOR_FAIL = "MAJOR_FAIL"
}

export enum CHECK_ITEM_OCCURRENCE_METRIC_ENUM {
  KILOMETERS = "KILOMETERS",
  DAYS = "DAYS"
}

export enum CHECK_ITEM_CONDITIONS_ENUM {
  EQUALS = "EQUALS",
  NOT_EQUALS = "NOT_EQUALS",
  LESS = "LESS",
  GREATER = "GREATER",
  IN_RANGE = "IN_RANGE"
}

export enum WarehouseTabs {
  sales = "sales",
  stock = "stock",
  suppliers = "suppliers"
}

export enum UsersTabs {
  clients = "clients",
  drivers = "drivers",
  ox_staff = "ox_staff"
}

export enum DRIVERS_SHOW_OPTIONS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  YES = "YES",
  NO = "NO"
}

export enum EBM_STATUS {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING"
}

export enum INSPECTION_TABS {
  CHECKGROUPS = "CHECKGROUPS",
  TRUCK_TYPES = "TRUCK_TYPES"
}

export const BUG_IMPACTS = ["LOW", "MEDIUM", "HIGH", "CRITICAL"] as const;
export type TBUG_IMPACT = (typeof BUG_IMPACTS)[number];

export enum FinancesTabs {
  expense_tracker = "expense_tracker",
  analytics = "analytics"
}

export enum EBMTabs {
  ebm = "ebm",
  purchases = "purchases",
  imports = "imports",
  notices = "notices"
}

export enum ExpensesTabs {
  reconciliation = "reconciliation",
  expense_tracker = "expense_tracker",
  analytics = "analytics"
}

export enum WarningsTabs {
  inspection_misuses = "inspection_misuses",
  order_misuses = "order_misuses"
}

export enum FleetTabs {
  trucks = "trucks",
  truck_health = "truck_health",
  utilization = "utilization"
}

export enum ENERGY_RECON_QUICK_DATE_FILTERS {
  THIS_MONTH = 30,
  THIS_QUARTER = 90,
  THIS_YEAR = 365
}

export enum EnergyTabs {
  energy_recon = "energy_recon"
}
